(() => {
  const root = document.querySelector('product-info');
  if (!root) return;
  if (!document.body.classList.contains('template-product-produit-fancy')) return;

  const qtyInput = root.querySelector('input.quantity__input');
  const qtyQuick = root.querySelector('[data-ep-qty-quick]');
  const qtyTotal = root.querySelector('[data-ep-qty-total-value]');
  const sticky = root.querySelector('[data-ep-sticky-atc]');
  const stickyPrice = root.querySelector('[data-ep-sticky-price]');
  const atcButton = root.querySelector(`#ProductSubmitButton-${root.dataset.section}`);
  const atcForm = root.querySelector('product-form');
  const appBlock = document.querySelector('#fpd-customize-button')?.closest('.shopify-block');
  const customizeButton = document.querySelector('#fpd-customize-button');
  const tierPicker = root.querySelector('[data-ep-tier-picker]');

  const getCurrency = () => sticky?.dataset.epCurrency || 'EUR';
  const getLocale = () => sticky?.dataset.epLocale || 'fr-FR';

  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(getLocale(), {
        style: 'currency',
        currency: getCurrency(),
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e) {
      return `${value.toFixed(2)} ${getCurrency()}`;
    }
  };

  const getCurrentVariant = () => {
    const jsonEl = root.querySelector('variant-selects [data-selected-variant]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  };

  const getVariantPayload = () => {
    const sectionId = root.dataset.section;
    if (!sectionId) return [];

    const variantsJson = document.getElementById(`EpProductVariants-${sectionId}`);
    if (!variantsJson) return [];

    try {
      const parsed = JSON.parse(variantsJson.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  };

  const getSelectedOptionMap = () => {
    const variantSelects = root.querySelector('variant-selects');
    if (!variantSelects) return {};

    return Array.from(variantSelects.querySelectorAll('[data-ep-option-position]')).reduce((acc, group) => {
      const optionPosition = Number(group.dataset.epOptionPosition || 0);
      if (!optionPosition) return acc;

      const select = group.querySelector('select');
      if (select?.value) {
        acc[optionPosition] = select.value;
        return acc;
      }

      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked?.value) {
        acc[optionPosition] = checked.value;
      }

      return acc;
    }, {});
  };

  const resolveVariantFromSelection = () => {
    const variants = getVariantPayload();
    const selectedOptions = getSelectedOptionMap();

    if (!variants.length || !Object.keys(selectedOptions).length) {
      return getCurrentVariant();
    }

    return (
      variants.find((variant) => {
        if (!variant) return false;
        if (selectedOptions[1] && variant.option1 !== selectedOptions[1]) return false;
        if (selectedOptions[2] && variant.option2 !== selectedOptions[2]) return false;
        if (selectedOptions[3] && variant.option3 !== selectedOptions[3]) return false;
        return true;
      }) || getCurrentVariant()
    );
  };

  const syncVariantUrl = () => {
    const variant = resolveVariantFromSelection();
    if (!variant?.id) return;

    const nextUrl = new URL(window.location.href);
    const currentVariantId = nextUrl.searchParams.get('variant');
    const nextVariantId = String(variant.id);

    if (currentVariantId === nextVariantId) return;

    nextUrl.searchParams.set('variant', nextVariantId);
    window.history.replaceState({}, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
  };

  const updateTotals = () => {
    const variant = getCurrentVariant();
    const unit = variant?.price ?? 0;
    const qty = Number(qtyInput?.value || 0);
    const total = unit * qty;

    if (qtyTotal) qtyTotal.textContent = formatMoney(total);
    if (stickyPrice) stickyPrice.textContent = formatMoney(unit);
  };

  const formatUnitPrice = (unitValue, unitLabel) => {
    const currency = getCurrency();
    const fallbackUnitLabel = currency === 'EUR' ? '€/pièce' : `${currency}/pièce`;
    const formatted = new Intl.NumberFormat(getLocale(), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(unitValue);
    return `${formatted} ${unitLabel || fallbackUnitLabel}`;
  };

  const updateTierUnits = () => {
    if (!tierPicker) return;
    const tierUnitLabel = tierPicker.dataset.epTierUnitLabel || '';
    const rows = tierPicker.querySelectorAll('[data-ep-tier-row]');
    rows.forEach((row) => {
      const unitEl = row.querySelector('[data-ep-tier-unit]');
      if (!unitEl) return;
      const unitCents = Number(row.dataset.epTierUnitCents || 0);
      if (!unitCents) return;
      unitEl.textContent = formatUnitPrice(unitCents / 100, tierUnitLabel);
    });
  };

  const updateTierSavings = () => {
    if (!tierPicker) return;
    const savingsEl = tierPicker.querySelector('[data-ep-tier-savings]');
    if (!savingsEl) return;

    const checkedInput = tierPicker.querySelector('input[type="radio"]:checked');
    if (!checkedInput) {
      savingsEl.textContent = '—%';
      return;
    }

    const checkedRow = checkedInput.closest('.ep-tier-picker__item')?.querySelector('[data-ep-tier-row]');
    if (!checkedRow) {
      savingsEl.textContent = '—%';
      return;
    }

    const selectedQty = Number(checkedRow.dataset.epTierQty || 0);
    const selectedUnitCents = Number(checkedRow.dataset.epTierUnitCents || 0);
    const selectedUnit = selectedQty ? selectedUnitCents : 0; // cents per piece
    if (!selectedUnit) {
      savingsEl.textContent = '—%';
      return;
    }

    let bestHigherUnit = null;
    const rows = tierPicker.querySelectorAll('.ep-tier-picker__item:not([hidden]) [data-ep-tier-row]');
    rows.forEach((row) => {
      const qty = Number(row.dataset.epTierQty || 0);
      const unitCents = Number(row.dataset.epTierUnitCents || 0);
      if (!qty || qty <= selectedQty) return;
      if (!unitCents) return;
      if (bestHigherUnit === null || unitCents < bestHigherUnit) bestHigherUnit = unitCents;
    });

    if (bestHigherUnit === null) {
      savingsEl.textContent = '—%';
      return;
    }

    const pct = Math.round((1 - bestHigherUnit / selectedUnit) * 100);
    savingsEl.textContent = pct > 0 ? `${pct}%` : '—%';
  };

  if (qtyQuick && qtyInput) {
    qtyQuick.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-ep-qty]');
      if (!btn) return;
      const nextQty = Number(btn.dataset.epQty || 0);
      if (!nextQty) return;
      qtyInput.value = String(nextQty);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateTotals();
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', updateTotals);
    qtyInput.addEventListener('change', updateTotals);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      updateTotals();
      updateTierSavings();
      syncVariantUrl();
    });
  }

  // Description clamp toggle
  root.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ep-product-desc-toggle]');
    if (!toggle) return;
    const wrapper = toggle.closest('[data-ep-product-desc]');
    if (!wrapper) return;

    const isExpanded = wrapper.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    const label = toggle.querySelector('span');
    const moreLabel = toggle.dataset.epLabelMore || 'En savoir plus';
    const lessLabel = toggle.dataset.epLabelLess || 'Réduire';
    const nextLabel = isExpanded ? lessLabel : moreLabel;
    if (label) {
      label.textContent = nextLabel;
    } else {
      toggle.textContent = nextLabel;
    }
  });

  // Rating click -> scroll to reviews (Judge.me / Shopify reviews / fallback)
  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ep-scroll-to-reviews]');
    if (!link) return;
    event.preventDefault();

    const selectors = [
      '#judgeme_product_reviews',
      '.jdgm-rev-widg',
      '#shopify-product-reviews',
      '.spr-container',
      '#reviews',
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (!el) continue;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      break;
    }
  });

  // Sticky ATC (mobile)
  if (sticky && atcButton) {
    const io = new IntersectionObserver(
      (entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);
        sticky.hidden = isVisible;
      },
      { threshold: 0.01 }
    );
    io.observe(atcButton);
  }

  if (customizeButton) {
    customizeButton.classList.remove('button--soft', 'button--secondary', 'button--tertiary');
    customizeButton.classList.add('button--primary');
  }

  if (appBlock) {
    appBlock.classList.add('ep-fancy-cta-configurator');
  }
  if (atcForm) {
    atcForm.classList.add('ep-fancy-cta-atc');
  }

  if (appBlock && atcForm && !root.querySelector('.ep-fancy-cta-row')) {
    const row = document.createElement('div');
    row.className = 'ep-fancy-cta-row';
    appBlock.parentElement?.insertBefore(row, appBlock);
    row.appendChild(appBlock);
    row.appendChild(atcForm);
  }

  if (tierPicker) {
    updateTierUnits();
    updateTierSavings();
    tierPicker.addEventListener('change', updateTierSavings);
  }

  updateTotals();
  syncVariantUrl();

  window.addEventListener('pageshow', syncVariantUrl);
  document.addEventListener('product-info:loaded', syncVariantUrl);
})();
